<script setup lang="ts">
type Props = {
  loading?: boolean
  /** Amount of placeholder cards */
  count: number
  inline?: boolean
}

withDefaults(defineProps<Props>(), {
  loading: true,
  inline: true,
})
</script>
<template>
  <div>
    <div v-if="loading" class="grid-wrapper grid gap-x-4 lg:gap-6">
      <LayoutCard
        v-for="card in count"
        :key="card"
        :gutter="false"
        class="mb-0 h-full animate-pulse overflow-hidden"
      >
        <div class="relative w-full overflow-hidden bg-zinc-300 pb-[56.15%]">
          <div
            class="absolute top-0 left-0 h-auto w-full max-w-full rounded-t-xl transition-all"
          >
            <div class="absolute top-0 left-0 w-full" />
          </div>
        </div>
        <div class="p-3">
          <div class="h-4 w-3/4 rounded-sm bg-zinc-400" />
        </div>
      </LayoutCard>
    </div>
    <div v-else class="grid-wrapper grid gap-4 lg:gap-6">
      <slot />
    </div>
  </div>
</template>
<style scoped>
/* Tailwind only generates classes that are used. If we use lg:grid-cols-${count}, tailwind cant detect the class. It'll work if it's used elsewhere
in the project but we can't count on that.
See: https://tailwindcss.com/docs/content-configuration#dynamic-class-names */
@media (min-width: 1024px) {
  .grid-wrapper {
    grid-template-columns: repeat(v-bind(count), minmax(0, 1fr));
  }
}
</style>
